import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { ProjectList } from "@lumanity/ui/projects";
import { Button } from "@lumanity/ui/primitives";

/** App admins get every PubCreator project from the service, not only the ones they're on. */
const AllProjects = () => {
  const navigate = useNavigate();

  return (
    <ProjectList
      onOpen={(project) => navigate(`/projects/${project.id}`)}
      onEdit={(project) => navigate(`/projects/${project.id}/edit`)}
      emptyText="No projects yet."
      toolbarActions={
        <Button size="sm" onClick={() => navigate("/projects/new")}>
          <Plus className="w-4 h-4 mr-1" />
          New Project
        </Button>
      }
    />
  );
};

export default AllProjects;
